import { useSelector } from 'react-redux'

import type { MenuRecipesState, Recipe, RecipeUUID } from 'reducers/menu-recipes/recipes'
import { getRecipe } from 'selectors/menu-recipes/getRecipe'

/**
 * Returns recipes by ids that are offered in the currently selected menu (for a currently selected number of portions)
 */
export const useRecipes = (ids: (RecipeUUID | null)[]): (Recipe | null)[] =>
  useSelector((state: MenuRecipesState) => ids.map((id) => (id ? getRecipe(id)(state) : null)))
